import * as React from "react";
interface SVGProps {
  height?: number | string;
  width?: number | string;
  color?: string;
}

const SvgArrowRightDisplay = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="53"
      height="48"
      viewBox="0 0 53 48"
      fill="none"
      {...props}
    >
      <path
        d="M29.1523 47.8438L24.6172 43.3438L32.668 35.2578C33.5586 34.4141 34.4609 33.5469 35.375 32.6562C36.2891 31.7656 37.2148 30.8867 38.1523 30.0195C39.1133 29.1289 40.0508 28.25 40.9648 27.3828C41.9023 26.5156 42.8164 25.6836 43.707 24.8867L44.1289 26.9961C43.1445 27.0664 42.125 27.125 41.0703 27.1719C40.0391 27.2188 38.9961 27.2656 37.9414 27.3125C36.8867 27.3359 35.832 27.3477 34.7773 27.3477H0.324219V20.8086H34.7773C35.832 20.8086 36.8867 20.832 37.9414 20.8789C38.9961 20.9023 40.0391 20.9375 41.0703 20.9844C42.125 21.0312 43.1445 21.0898 44.1289 21.1602L43.707 23.2695C42.5352 22.1914 41.3164 21.0781 40.0508 19.9297C38.8086 18.7578 37.5547 17.5859 36.2891 16.4141C35.0469 15.2188 33.8398 14.0469 32.668 12.8984L24.582 4.84766L29.1523 0.3125L52.918 24.0781L29.1523 47.8438Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SvgArrowRightDisplay;
